import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IBackupState} from "../reducers/backup.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBackupListState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.backupList);

export const getWebsiteBackupList = (websiteId: number) => createSelector(getBackupListState,
  (state: IBackupState) =>
    state.entities[websiteId] && state.entities[websiteId].entities ? Object.values(state.entities[websiteId].entities) : null
);
